import callAPI from "../callApi";
import path from "../variables";

const Refunds = {
	getAll: (filter?: string) =>
		callAPI("GET", `${path.base}/refunds${filter || ""}`, "", "getting all refunds"),
	create: (data: any) =>
		callAPI("POST", `${path.base}/refunds`, data, "creating refund request"),
	show: (id: number) =>
		callAPI("GET", `${path.base}/refunds/${id}`, "", "getting refund details"),
	approve: (id: number) =>
		callAPI("POST", `${path.base}/refunds/${id}/approve`, "", "approving refund"),
	process: (id: number) =>
		callAPI("POST", `${path.base}/refunds/${id}/process`, "", "processing refund"),
	reject: (id: number, data: any) =>
		callAPI("POST", `${path.base}/refunds/${id}/reject`, data, "rejecting refund"),
	// Totaux mensuels des remboursements processés (alimente la 3ème
	// courbe du dashboard évolutions). Format identique à
	// expenses.getMonthlyTotalsStatsByPeriod : [{ month, total }, …].
	getMonthlyTotalsByPeriod: (filter?: string) =>
		callAPI(
			"GET",
			`${path.base}/refunds/monthly-totals-by-period${filter || ""}`,
			"",
			"getting monthly refund totals",
		),
	// 3 cards synthétiques (Journalier / Hebdo / Mensuel). Pendant
	// de expenses.getTotalsStats — même format de réponse.
	getTotalsStats: (filter?: string) =>
		callAPI(
			"GET",
			`${path.base}/refunds/totals-stats${filter || ""}`,
			"",
			"getting refund totals stats",
		),
};

export default Refunds;
